import { useEffect, useState } from 'react';

// Tiempo de espera estándar para buscadores: espera a que el usuario deje de
// escribir antes de disparar la búsqueda, evitando una petición por cada tecla.
export const SEARCH_DEBOUNCE_MS = 1500;

export function useDebounce<T>(value: T, delay: number = SEARCH_DEBOUNCE_MS): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}